var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page",class:{'sign-in-page': _vm.routerName === 'sign-in'}},[_c('v-fade-transition',[_c('router-view',{key:_vm.getKey})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }